import React from 'react';
import { translate } from '../../../utils/translations';
import PropTypes from 'prop-types';
import { SUFFIXES } from '../../../utils/globals';

const { temperature } = SUFFIXES;

const TempFormatInput = props => (
    <div className="form__item">
        <label htmlFor="tempFormat">
            {translate(props.language, 'label_temp_format')}
        </label>
        <select
            name="tempFormat"
            id="tempFormat"
            className="select-format"
            value={props.tempFormat}
            onChange={props.handleChange}
        >
            <option value={temperature.celsius}>
                {translate(props.language, 'label_celsius')}
            </option>
            <option value={temperature.fahrenheit}>
                {translate(props.language, 'label_fahrenheit')}
            </option>
        </select>
    </div>
);

TempFormatInput.propTypes = {
    language: PropTypes.string,
    tempFormat: PropTypes.string,
    handleChange: PropTypes.func,
};

export default TempFormatInput;



// WEBPACK FOOTER //
// ./src/containers/Configurador/FormPartials/TempFormatInput.js